import { render, staticRenderFns } from "./GroupFileChangeHistory.vue?vue&type=template&id=bf72d51c&scoped=true"
import script from "./GroupFileChangeHistory.vue?vue&type=script&lang=js"
export * from "./GroupFileChangeHistory.vue?vue&type=script&lang=js"
import style0 from "./GroupFileChangeHistory.vue?vue&type=style&index=0&id=bf72d51c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf72d51c",
  null
  
)

export default component.exports